module.exports = __webpack_public_path__ + "img/mb_img_process_04.d499a861.png";